import { Box } from '@mui/material';

interface RequiredLabelProps {
  children: React.ReactNode;
}

const RequiredLabel = ({ children }: RequiredLabelProps) => {
  return (
    <Box component="span">
      {children}{' '}
      <Box component="span" sx={{ color: 'error.main' }}>
        *
      </Box>
    </Box>
  );
};

export default RequiredLabel;
